function resisted(y, minY, maxOverflow = 25) {
  if (y >= minY) return y;
  const pastBoundary = minY - y,
    resistedDistance = Math.sqrt(pastBoundary) * 2;
  return minY - resistedDistance;
}
export { resisted };
//# sourceMappingURL=helpers.mjs.map
